<template>
  <div class="row">
    <!--    <div class="col-12 mb-3">-->
    <!--      <button class="btn btn-primary" @click="$router.push({name: 'edit_comment' , params: {id: 'new'}})">-->
    <!--        افزودن-->
    <!--        <i class="fas fa-plus"/>-->
    <!--      </button>-->
    <!--      <hr>-->
    <!--    </div>-->
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو نظر
      </h4>
    </div>
    <div class="col-12">
      <form class="text-right" v-on:keyup.enter="beaforeSearch">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group">
              <label for="user" class="text-right mb-1">کاربر</label>
              <appUserSelect :justId="true" id="user" placeholder="کاربر" v-model="filters.account_id" />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group">
              <label for="story" class="text-right mb-1">داستان</label>
              <appStorySelect :justId="true" id="story" placeholder="داستان" v-model="filters.ref_id" />
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="search">
                  <label for="sort" class="text-right mb-1">نمایش براساس</label>
                  <fv-select id="sort" class="fv-form-control" v-model="sort"
                             :options="[{text: 'جدیدترین',value:'-_score,-created_at'},{text: 'قدیمی ترین',value:'-_score,updated_at'}]"/>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="perpage" class="text-right mb-1">تعداد نمایش</label>
                  <fvSelect class="fv-form-control"
                            id="perpage"
                            @input="changePerPage"
                            :value="pagination.per_page"
                            :options="$store.state.main.per_page"
                            placeholder="تعداد نمایش"
                  >

                  </fvSelect>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="is_verified" class="text-right mb-1">وضعیت تایید</label>
                  <fvSelect class="form-control select text-right fv-size-md" id="is_verified"
                            v-model="filters.is_verified"
                            :options="[
                            		{text: 'تایید شده' , value: true},
                            		{text: 'تایید نشده' , value: false },
                            		 {text: 'تعیین وضعیت نشده' , value: null}
                            		 ]"
                            placeholder="وضعیت تایید"
                  >
                  </fvSelect>
                </div>
              </div>

            </div>
          </div>
          <div class="col-12 text-left d-flex">
            <button type="button" @click="$router.push({})" class="btn btn-danger ml-auto">
              حذف فیلترها
              <i class="fas fa-trash"/>
            </button>
            <button @click.prevent="beforeSearch" class="btn btn-info">
              جستجو
              <i class="fas fa-search"/>
            </button>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="item.length > 0" :fields="fields" :rows="item">
        <template slot="field-#" slot-scope="scope">
          <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>
        </template>
        <template slot="field-کاربر" slot-scope="scope">
          <div v-if="scope.row.account">
            {{scope.row.account.username || '---'}}
            <br/>
            <small dir="ltr">{{scope.row.account.mobile || '---'}}</small>
          </div>
        </template>
        <template slot="field-بخش" slot-scope="scope">
          {{scope.row.ref_type === 'STORY' ? 'داستان' : (scope.row.ref_type || '---') }}
        </template>
        <template slot="field-وضعیت" slot-scope="scope">
          <div v-if="scope.row.is_verified" class="text-success">
            تایید شده
            <i class="far fa-check-circle"/>
          </div>
          <div v-else-if="scope.row.is_verified === undefined" class="text-warning">
            در انتظار تایید
            <i class="far fa-clock"/>
          </div>
          <div v-else-if="scope.row.is_verified === false" class="text-danger">
            تایید نشده
            <i class="far fa-times-circle"/>
          </div>
        </template>
        <template slot="field-زمان" slot-scope="scope">
          {{$dateTimeFormat(scope.row.created_at) || '---'}}
        </template>
        <template slot="field-پیش نمایش" slot-scope="scope">
          <div class="commentPreview">{{scope.row.content || '---'}}</div>
        </template>

        <template slot="field-actions" slot-scope="scope">
          <button @click="$router.push({name: 'edit_comment' , params : {id: scope.row.id} })"
                  class="btn btn-warning btn-sm">
            تغییر
            <i class="far fa-edit"/>
          </button>
          <button @click="deleteRow(scope.row.id)"
                  class="btn btn-danger btn-sm mr-2">
            پاک کردن
            <i class="fas fa-trash"/>
          </button>
        </template>
      </fvTable>
    </div>
    <div class="col-12 text-center mt-5" v-if="Object.keys(item).length > 0 && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search"/>
    </div>

  </div>
</template>
<script>

	import { mapActions } from "vuex";
import appPagination from "../../components/appPagination";
import appStorySelect from "../../components/appStorySelect";
import appUserSelect from "../../components/appUserSelect";

	export default {
		name: 'category',
		components: {
			appUserSelect,
			appStorySelect,
			appPagination
		},
		data() {
			return {
				...mapActions('main', [
					'crud'
				]),
				item: [],
				fields: ['#', 'کاربر', 'بخش', 'وضعیت', 'پیش نمایش', 'زمان', 'actions'],
				query: {},
				filters: {},
				sort: '-_score,-created_at',
				page: 1,
				pagination: {per_page: 50}
			}
		},
		methods: {
			parseQueries() {
				const {query} = this.$route
				const {page, filters, sort, per_page} = query;
				const filtersObj = filters ? JSON.parse(filters) : {}


				this.sort = sort || '-_score,-created_at'
				this.filters = filtersObj
				this.query = query
				this.page = page ? parseInt(page) : 1
				this.pagination.per_page = per_page
			},
			async getData() {
				this.parseQueries()
				this.$store.commit('main/SET', {key: 'loading', value: true})
				try {
					const apiFilters = await this.$generateFilter(this.filters)
					const item = await this.crud({
						action: 'get',
						section: 'comments',
						query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}`,
						perPage: this.pagination.per_page

					})

					if (item.data && item.data.items) {
						const result = item.data.items
						this.item = result
						this.pagination = item.data.pagination
					}
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async search() {
				this.filters = await this.$validateFilter(this.filters)
				await this.$router.push({
					query: {
						filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
						sort: this.sort || undefined,
						page: this.page,
						per_page: this.pagination.per_page

					}
				})
			},
			async deleteRow(id) {
				if (!await this.$confirmAlert())
					return false

				this.$store.commit('main/SET', {key: 'loading', value: true})
				try {
					const deleted = await this.crud({
						action: 'delete',
						section: 'comments',
						id: id,
					})
					await this.$successAlert("با موفقیت پاک شد.")
					await this.getData()

				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			beforeSearch() {
				this.page = 1
				this.search()
			},
			changePerPage(value) {
				this.pagination.per_page = value
				this.beforeSearch()
			},
		},

		async created() {
			await this.getData()
		},
		watch: {
			'$route.query'() {
				this.getData();
			}
		},

		// beforeUpdate() {
		// }
	};
</script>
<style>
  .commentPreview {
    max-width: 350px;
    margin: 0 auto;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
